import Button, { TYPES } from 'components/Button'
import React from 'react'
import { clearFilters, getAppliedFiltersCount } from './utils'

/**
 * @param {Object} props - The props
 * @param {List} props.tiles - The tiles data list
 * @param {Map} props.staticText - The static text data
 * @param {String} props.filterSetType - The type of filter set object
 * @param {Map} props.auth - The auth data
 * @param {String} props.language - The user's language
 * @param {Object} props.location - The location object
 * @param {Object} props.history - The history object
 * @returns {JSX.Element} The Clear Filters component
 */

function FiltersV2Clear ({
  tiles,
  staticText,
  filterSetType,
  language,
  location,
  history,
  auth,
}) {
  const total = tiles.getIn(['subcategory', 'data', 'totalCount'], 0)
  const hasFilters = getAppliedFiltersCount(location, filterSetType) > 0

  if (!hasFilters) {
    return null
  }

  return (
    <div className="filters-v2__clear">
      <span className="filters-v2__total">
        {`${total} ${staticText.get('results')} -`}
      </span>
      <Button
        type={TYPES.GHOST}
        onClick={() => clearFilters({
          filterSetType,
          language,
          location,
          history,
          auth,
        })}
        className="filters-v2__clear-button"
      >
        {staticText.get('clearFilters')}
      </Button>
    </div>
  )
}

export default FiltersV2Clear
